import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SeasonalHighlight = ({ seasonal }) => {
  return (
    <div className="bg-gradient-to-br from-warning/20 to-accent/20 rounded-xl p-8 shadow-warm">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-14 h-14 bg-warning/30 rounded-lg flex items-center justify-center">
          <Icon name="Leaf" size={28} color="var(--color-warning)" />
        </div>
        <div>
          <h2 className="font-serif text-2xl font-semibold text-foreground">
            {seasonal?.title}
          </h2>
          <p className="text-sm text-muted-foreground">
            Available until {seasonal?.availableUntil}
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="relative h-80 rounded-xl overflow-hidden">
          <Image
            src={seasonal?.image}
            alt={seasonal?.imageAlt}
            className="w-full h-full object-cover"
          />
        </div>

        <div className="flex flex-col justify-center">
          <h3 className="font-serif text-3xl font-semibold text-foreground mb-3">
            {seasonal?.itemName}
          </h3>
          <p className="text-sm text-muted-foreground italic mb-4">
            {seasonal?.italianName}
          </p>
          <p className="text-foreground mb-6 leading-relaxed">
            {seasonal?.description}
          </p>

          <div className="bg-card rounded-lg p-4 mb-6">
            <div className="flex items-center gap-2 mb-3">
              <Icon name="Sparkles" size={18} color="var(--color-primary)" />
              <h4 className="font-medium text-foreground">Cultural Tradition</h4>
            </div>
            <p className="text-sm text-muted-foreground">
              {seasonal?.tradition}
            </p>
          </div>

          <div className="flex items-center gap-4">
            <span className="text-3xl font-semibold text-primary">
              ${seasonal?.price?.toFixed(2)}
            </span>
            <Button variant="default" iconName="ShoppingBag" iconPosition="left">
              Order Now
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeasonalHighlight;